import moment from 'moment-timezone'
import { UPS_CARRIER_TYPE } from '@Orders/constants'
import { salesOrder_salesOrder_shipments_items_trackingData_trackingDetails } from '@Orders/OrderDetailsPage/Queries/__generated__/salesOrder'

import Box from '~/core/Box'

export default function ShippingStatus(props: {
    trackingDetails: salesOrder_salesOrder_shipments_items_trackingData_trackingDetails
    carrier: string | null
    signedBy: string | null
}) {
    const {
        carrier,
        trackingDetails: { message, datetime },
        signedBy,
    } = props

    const location =
        props?.trackingDetails && props?.trackingDetails?.trackingLocation

    let shippingStatusDate: string

    // UPS returns timestamps in the timezone of the package scan
    // FedEx returns timestamps in UTC and are converted to users local time
    if (UPS_CARRIER_TYPE === carrier) {
        shippingStatusDate = moment
            .utc(datetime)
            .format('MMMM DD, YYYY [at] hh:mm A')
    } else {
        const date = moment(datetime).format('MMMM DD, YYYY [at] hh:mm A')
        const localZone = moment.tz.zone(moment.tz.guess())?.abbrs[0]

        shippingStatusDate = `${date} ${localZone}`
    }

    return (
        <Box display="block">
            <Box marginTop="5px">{message}</Box>
            {signedBy ? <div>Signed by {signedBy}</div> : ''}
            {location?.city || location?.state || location?.postalCode ? (
                <div>
                    {location.city}
                    {', '}
                    {location.state} {location.postalCode}
                </div>
            ) : (
                ''
            )}
            <div>{shippingStatusDate}</div>
        </Box>
    )
}
